const value = {
    login: 'Вход',
    learning: 'Знания',
    notifications: 'Уведомления',
    analytics: 'Аналитика',
    settings: 'Настройки',
    projects: 'Проекты',
    project: 'Проект',
    systemPage: 'Страница системы',
    editProject: 'Редактировать проект',
    addProject: 'Добавить проект',
    passing: 'Прохождение',
    editUnit: 'Редактирование юнита',
    createUnit: 'Создание юнита',
    unitPreview: 'Предпросмотр юнита',
    userRating: 'Рейтинг пользователя',
  };

export default value;
